<!--
 * @Author: your name
 * @Date: 2021-07-08 18:19:46
 * @LastEditTime: 2021-07-20 20:17:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\flool1.vue
-->
<template>
  <div class="floor-wrapper">
    <div class="floor-hidden" v-if="floorData.isHidden">
      <el-divider
        >{{ floorData.title ? floorData.title : '标题' }}区</el-divider
      >
      <div class="open-btn">
        <eui-btn width="80" type="primary" @click.native.prevent="hiddenFloor"
          >显示</eui-btn
        >
      </div>
    </div>
    <div :class="{ 'content-border': showBorder }" v-else>
      <div class="floor-top flex-sb">
        <p class="floor-title">
          {{ floorData.title ? floorData.title : '标题' }}
        </p>
        <p v-if="floorData.linkUrl" class="floor-more">查看更多</p>
      </div>
      <div class="product-content" v-if="floorData.productList.length > 0">
        <productListImg
          class="product-item"
          v-for="(item, index) in floorData.productList"
          :itemData="item"
          :itemIndex="index"
          :key="index"
        ></productListImg>
      </div>
      <div class="product-content" v-else>
        <productListImg
          class="product-item"
          v-for="(item, index) in defaultProductList"
          :itemData="item"
          :itemIndex="index"
          :key="index"
        ></productListImg>
      </div>
    </div>
  </div>
</template>

<script>
import productListImg from './productListImg';
import { defaultData } from './data/defaultData';

export default {
  props: {
    activeName: {
      type: String,
      default: '',
    },
    floorData: {
      type: Object,
      default() {
        return {
          isHidden: false,
          title: '',
          linkUrl: '',
          productList: [],
        };
      },
    },
  },
  components: {
    productListImg,
  },
  computed: {
    showBorder() {
      // eslint-disable-next-line eqeqeq
      return this.activeName == 'floor1';
    },
  },
  data() {
    return {
      defaultProductList: JSON.parse(JSON.stringify(defaultData.productList)),
    };
  },
  methods: {
    hiddenFloor() {
      // eslint-disable-next-line vue/no-mutating-props
      this.floorData.isHidden = !this.floorData.isHidden;
      this.$parent.choosenComments('');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/theme.scss';
.floor-wrapper {
  position: relative;
}
.floor-wrapper:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.floor-top {
  height: 60px;
  line-height: 60px;
  width: 1200px;
  border-bottom: 1px solid $main-col;
  .floor-title {
    font-weight: bold;
    font-size: 30px;
    border-bottom: 3px solid $main-col;
    width: 200px;
    cursor: pointer;
  }
  .floor-more {
    font-size: 20px;
    color: $main-col;
    cursor: pointer;
  }
}
.product-content {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  .product-item {
    margin-bottom: 20px;
  }
}
.content-border:after {
  content: '';
  position: absolute;
  left: 0px;
  bottom: 0;
  top: 0;
  right: 0;
  border: 2px dashed red;
}
.floor-hidden {
  width: 1200px;

  background: #f8f8f9;
  position: relative;
  .open-btn {
    position: absolute;
    top: -16px;
    right: 0;
  }
  p {
    width: 100%;
    height: 0;
    border-top: 1px solid #eee;
  }
}
</style>
